import { Role } from './role.model';
export class Utilisateur {
    public id: number;
    public nom: string;
    public email: string;
    public password: string;
    public role: Role;
    constructor(id, nom, email, password, role) {
        this.id = id;
        this.nom = nom;
        this.email = email;
        this.password = password;
        this.role = role;
    }

    get getId(){
        return this.id;
    }
}
